import { ChangeEventHandler } from "react";
import IsRequired from "./common/IsRequired";

export default function InputRadio(props: {
  label: string;
  className?: string;
  id: string;
  name: string;
  checked: boolean;
  onChange: ChangeEventHandler<HTMLInputElement>;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  disabled?: boolean;
  isRequired?: boolean;
}) {
  const {
    label,
    className,
    id,
    name,
    checked,
    onChange,
    onBlur,
    disabled,
    isRequired,
  } = props;
  return (
    <div className={`form-check${className ? ` ${className}` : ""}`}>
      <input
        disabled={disabled}
        className="form-check-input"
        type="radio"
        name={name}
        id={id}
        checked={checked}
        onChange={onChange}
        onBlur={onBlur}
      />
      <label className="form-check-label" htmlFor={id}>
        {label}
        {isRequired && <IsRequired />}
      </label>
    </div>
  );
}
